import * as React from 'react';
import { Table } from 'antd';

export type Props = {
  loading?: boolean;
  columns: Array<{
    title: string | React.ReactNode;
    dataIndex?: string;
    render?: (arg: any) => React.ReactNode;
    width?: string;
  }>;
  dataSource: any[];
  className?: string;
  rowClassName?: string;
};

const AdminTable = ({ className, rowClassName, loading, columns, dataSource }: Props) => (
  <Table
    className={className}
    rowClassName={rowClassName}
    loading={loading}
    columns={columns}
    dataSource={dataSource}
    pagination={false}
  />
);

export default AdminTable;
